/* eslint-disable */

import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "material-ui/styles";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from "material-ui/Table";
import green from "material-ui/colors/green";
import { CircularProgress } from "material-ui/Progress";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Tooltip from "material-ui/Tooltip";
import Button from "material-ui/Button";
import AddIcon from "material-ui-icons/Add";
import { withRouter } from "react-router";
import { lighten } from "material-ui/styles/colorManipulator";

import {
  getAssetsConsumingStart,
  sortAssetsConsuming,
  changePage,
  changeRowsPerPage,
  getUsername
} from "../actions";
import { translate } from "react-i18next";
import { checkUserIsAdmin } from '../utils/user/checkAdmin/CheckAdmin';


const columnData = [
  { id: "city", numeric: false, disablePadding: false, label: "Asset" },
  { id: "organization", numeric: false, disablePadding: false, label: "Organization" }
];

class AssetsConsumingHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      order,
      orderBy,
      t,
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? "none" : "default"}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t("Sort")}
                  placement={column.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

AssetsConsumingHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  spacer: {
    flex: "1 1 100%"
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    flex: "0 0 auto"
  }
});

let AssetsConsumingToolbar = props => {
  const { numSelected, classes, loading, t } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            {t("Consuming assets")}
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Typography>
        )}
      </div>
    </Toolbar>
  );
};

AssetsConsumingToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired
};

AssetsConsumingToolbar = withStyles(toolbarStyles)(AssetsConsumingToolbar);

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  buttonProgress: {
    color: green[500],
    position: "relative",
    bottom: -30,
    left: 100,
    marginTop: -12,
    marginLeft: -12
  }
});

class AssetsConsuming extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: "asc",
      orderBy: "id",
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 5
    };
  }

  componentDidMount = async () => {
    const authenticationCheck = await localStorage.getItem("isAuthenticated");
    if (authenticationCheck) {
      this.props.getAssetsConsumingStart();
    } else {
      this.props.history.push("/");
    }
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.props.orderBy === property && this.props.order === "desc") {
      order = "asc";
    }

    const assets =
      order === "desc"
        ? this.props.assets.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
        : this.props.assets.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

    this.props.sortAssetsConsuming(assets, order, orderBy);
  };

  handleChangePage = (event, page) => {
    this.props.changePage(page);
  };

  handleClick = (event, id) => {
    this.props.history.push("/assets/cons/read/" + id);
  };

  //Below are functions provided initially by material ui
  //Visit https://material-ui-next.com/demos/tables/#sorting-amp-selecting for details

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.state.data.map(n => n.id) }); //Do this redux way
      return;
    }
    this.setState({ selected: [] }); //Do this redux way
  };

  handleClickSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangeRowsPerPage = event => {
    this.props.changeRowsPerPage(event.target.value);
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  renderCreateButton() {
    const { classes, user, isAuthenticated } = this.props;
    if (checkUserIsAdmin(isAuthenticated, user)) {
      return (
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.button}
          style={{
            margin: 0,
            bottom: "auto",
            right: 48,
            top: 85,
            left: "auto",
            position: "fixed",
            cursor: "pointer"
          }}
          onClick={() => {
            this.props.history.push("/assets/cons/create");
          }}
        >
          <AddIcon />
        </Button>
      );
    } else return false;
  }

  render() {
    const { classes } = this.props;
    const {
      assetsConsuming,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      loading,
      t,
      i18n
    } = this.props;
    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, assetsConsuming.length - page * rowsPerPage);

    return (
      <div className={classes.root}>
        <Paper className={classes.root}>
          <AssetsConsumingToolbar
            numSelected={selected.length}
            loading={loading}
            t={t}
            i18n={i18n}
          />
          <div className={classes.tableWrapper}>
            <Table className={classes.table} style={{ minWidth: 0 }}>
              <AssetsConsumingHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={assetsConsuming.length}
                t={t}
                i18n={i18n}
              />
              <TableBody>
                {assetsConsuming
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(n => {
                    const isSelected = this.isSelected(n.id);
                    if (!n.active)
                      return (
                        <TableRow
                          hover
                          onClick={event => this.handleClick(event, n.id)}
                          role="checkbox"
                          aria-checked={isSelected}
                          tabIndex={-1}
                          key={n.id}
                          selected={isSelected}
                        >
                          <TableCell
                            style={{
                              cursor: "pointer"
                            }}
                          >{n.displayedName ? n.displayedName : n.city}</TableCell>
                          <TableCell
                            style={{
                              cursor: "pointer"
                            }}
                          >{n.organization ? n.organization.name : "No organization"}</TableCell>
                        </TableRow>
                      );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={assetsConsuming.length}
            labelDisplayedRows={({ from, to, count }) =>
              from + "-" + to + t(" of ") + count
            }
            labelRowsPerPage={t("RowsPerPage")}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        {this.renderCreateButton()}
      </div>
    );
  }
}

AssetsConsuming.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = ({
  assetsConsumingReducer,
  router,
  loginReducer
}) => {
  const {
    currentAssetConsuming,
    assetsConsuming,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage
  } = assetsConsumingReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;

  let archivedAssetsConsuming = assetsConsuming.filter(assetConsuming => !assetConsuming.active)

  return {
    currentAssetConsuming,
    assetsConsuming: archivedAssetsConsuming,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    location,
    isAuthenticated,
    username,
    user
  };
};

const mapDispatchToProps = {
  getAssetsConsumingStart,
  sortAssetsConsuming,
  changePage,
  changeRowsPerPage,
  getUsername
};

AssetsConsuming = withStyles(styles, { name: "AssetsConsuming" })(
  AssetsConsuming
);
AssetsConsuming = translate("translations")(AssetsConsuming);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AssetsConsuming)
);



// WEBPACK FOOTER //
// ./src/components/AssetsConsumingArchived.js